import { render, staticRenderFns } from "./OrderSubmitted.vue?vue&type=template&id=f0280cf8&scoped=true&"
import script from "./OrderSubmitted.vue?vue&type=script&lang=js&"
export * from "./OrderSubmitted.vue?vue&type=script&lang=js&"
import style0 from "./OrderSubmitted.vue?vue&type=style&index=0&id=f0280cf8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f0280cf8",
  null
  
)

export default component.exports